import * as Styled from './pop-over.styles';
import type { PopOverPrimitiveProps } from './pop-over.types';

export const PopOverPrimitive = ({
  children,
  className,
  containerRef,
  position,
  ...props
}: PopOverPrimitiveProps): JSX.Element => (
  <Styled.Wrapper
    className={className}
    data-xds="PopOver"
    ref={containerRef}
    style={{ ...position }}
    tabIndex={-1}
    {...props}
  >
    {children}
  </Styled.Wrapper>
);

PopOverPrimitive.displayName = 'PopOver (Primitive)';
